export default __webpack_public_path__ + "static/media/deleteTransactionRules.3592f154.svg";